module.exports = __webpack_public_path__ + "assets/location-5a6d32.svg";